export enum PatientsSortBy {
  NAME = 'name',
  SYNC_STATE = 'syncState',
  BP_TYPE = 'bpType',
}
